import { Address } from '@dreryk/address-common-api';

export const isPatientAddressForPrescriptionIncomplete = (patientAddress: Address): boolean => {
   const country = patientAddress.getCountry();
   const town = patientAddress.findTown();
   const postcode = patientAddress.findPostcode();
   const building = patientAddress.findBuilding();

   return !country || !town || !postcode || !building;
};
